import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveMappingType } from './index';

// Api's
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';
import { integrationCodeApi } from '@/main/api';

export function* getMappingTypeSaga() {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      integrationCodeApi.domain
    );

    if (response.data.result) {
      yield put(saveMappingType(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveMappingType(null, true, resultError.messagesDataError));
    }
  }
}

